module.exports = "<slot></slot>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/FormGroup.vue
// module id = 135
// module chunks = 0